<template>
  <div class="home page">
    <div class="pure-g container">
      <div class="pure-u-1-2 make-relative">
        <img src="/img/home-logo.png" alt="">
        <div class="vertical-align">
          <div class="header-overlay font-white">
            RAVINE TOWNS
          </div>
        </div>
      </div>
      <div class="pure-u-1-2 make-relative">
        <img src="/img/home-image.png" alt="">
        <div class="logo-container">
          <img src="/img/logo/primont.svg" alt="">
        </div>
        <div class="home-nav">
          <router-link to="/floorplans">FLOORPLANS</router-link> 
          <router-link to="/siteplan">SITE PLAN</router-link> 
          <router-link to="/gallery">GALLERY</router-link>
          <a href="http://sxsw-2023.joeyai.tv/">CONDOS</a>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  mounted () {
    // ...
    //console.log("..", document.querySelector("#nav"));
    document.querySelector("#nav").style.display= "none";
  },
  beforeRouteLeave (to, from, next) {
    // ...
    document.querySelector("#nav").style.display= "block";
    next();
  }
}
</script>

<style lang="scss">
  .page.home {
    height: 1080px;
    max-height: 1080px;
    z-index: 10;
  }

  .header-overlay {
    font-size: 50px;
    font-weight: 300;
    letter-spacing: 0.2em;
    
  }
  .logo-container {
    position: absolute;
    bottom: 70px;
    top: auto;
    width: 100%;
    text-align: center;

  }
  .home-nav {
    position: absolute;
    bottom: 233px;
    top: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    a {
      padding: 22px 53px;
      font-size: 1em;
      letter-spacing: 0.1em;
      border: 1px solid white;
      margin: 0 5px;
      color: white;
      font-weight: bold;
    }
  }

</style>
